import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-herramientas',
  templateUrl: './herramientas.component.html',
  styleUrls: ['./herramientas.component.scss']
})
export class DocumentProcessingComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigateToExcelConverter() {
    this.router.navigate(['/backoffice/holded-to-sage200']);
  }

  navigateToExcelConverter2025() {
    this.router.navigate(['/backoffice/holded-to-sage200-2025']);
  }

  navigateToCdrProcessing() {
    this.router.navigate(['/backoffice/cdr-processing']);
  }

  navigateToEsimCatalog() {
    this.router.navigate(['/backoffice/esim-catalog']);
  }

  navigateToDocumentStore() {
    this.router.navigate(['/backoffice/document-store']);
  }

  navigateToCdrBilling() {
    this.router.navigate(['/backoffice/cdr-billing']);
  }
}
